/**
 * @author Manifold Finance, Inc.
 * @date July, 12, 2023
 * @license GPL-3.0
 */

import AccountStatus from '@/components/enFOLD/AccountStatus';
import Background from '@/components/enFOLD/Background';
import {
  CardInnerContainerTeam,
  CardOuterContainerTeam,
  HeaderContainer,
  LogoImage,
  SmallCube,
} from '@/components/general/Card';
import ExtraInfoPluStakeButton from '@/components/general/ExtraInfoPluStakeButton';
import StakingButton from '@/components/general/StakingButton';
import StakeCenterFold from '@/components/legal/StakeCenterFold';
import DefaultLayout from '@/layout/DefaultLayout';
import { AnimatePresence, LayoutGroup, motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import React, { useState } from 'react';

const FAQSection = dynamic(() => import('@/components/dashboard/FAQSection'), {
  ssr: false,
});

function Header() {
  return (
    <HeaderContainer>
      <Link href="/">
        <LogoImage src="/svg/MEV Text White.svg" alt="mevETH" />
      </Link>
      <StakingButton style={{ marginTop: 3 }}>
        <a href="/stake">Start staking ETH</a>
      </StakingButton>
    </HeaderContainer>
  );
}

function Card() {
  // const [stakeMode, setStakeMode] = useState<"Ready" | "Loading" | "Convert">(
  return (
    <LayoutGroup>
      <CardOuterContainerTeam
        initial={{ transform: 'scale(0.9)' }}
        animate={{ transform: 'scale(1)' }}
        exit={{ transform: 'scale(0.9)' }}
        layout
      >
        <AccountStatus />
        <CardInnerContainerTeam>
          <AnimatePresence>
            <StakeCenterFold />
          </AnimatePresence>
        </CardInnerContainerTeam>
      </CardOuterContainerTeam>
    </LayoutGroup>
  );
}

export default function TeamPage() {
  return (
    <DefaultLayout>
      <Header />
      <Card />
      <Background />
    </DefaultLayout>
  );
}
